import { IconButton } from "@mui/material";
import { Box, MenuOpenRounded } from "components/common";

import { ReactComponent as Logo } from "assets/icons/Logo.svg";

interface DrawerHeaderProps {
  isTemporary?: boolean;
  onClose?: () => void;
}

export default function DrawerHeader({ isTemporary = false, onClose }: DrawerHeaderProps) {
  return (
    <Box
      display="flex"
      justifyContent={isTemporary ? "space-between" : "center"}
      alignItems="center"
      pt={1}
      pb={1}
      px={2}
      position="absolute"
      top={0}
      height="calc(100px - 16px)"
      width="calc(100% - 32px)"
    >
      {isTemporary && (
        <IconButton
          disableRipple
          aria-label="close drawer"
          onClick={onClose}
          edge="start"
          color="secondary"
        >
          <MenuOpenRounded
            sx={{
              color: "#747474",
            }}
          />
        </IconButton>
      )}
      <Logo width={200} height="100%" />
      {isTemporary && <Box width={40} />}
    </Box>
  );
}
